<div id="bubbleMaplinechartDiv"></div>
    <div id="d3BubbleLineTooltip">
        <app-general-tooltip-popup [data]="bubbleLineTooltipData" date="true" *ngIf="showBubbleLineTooltip"></app-general-tooltip-popup>
    </div>
